@if (appGroups) {
  <div class="contents">
    @if (appGroups.picture?.length) {
      <div class="app-group">
        @for (app of appGroups.picture; track app.ID) {
          <motn-image-card-app
            [app]="app"
          ></motn-image-card-app>
        }
      </div>
    }

    @if (appGroups.propManager?.length) {
      <div class="app-group">
        @for (app of appGroups.propManager; track app.ID) {
          <motn-image-card-app
            [app]="app"
          ></motn-image-card-app>
        }
      </div>
    }

    @if (appGroups.tenantPortal?.length) {
      <div class="app-group">
        @for (app of appGroups.tenantPortal; track app.ID) {
          <motn-image-card-app
            [app]="app"
          ></motn-image-card-app>
        }
      </div>
    }
  </div>
}
